import "./Footer.css"

function Footer() {
    return(
        <div className="Footer">
            Footer
        </div>
    )
}
export default Footer